// extracted by mini-css-extract-plugin
module.exports = {"module":"_1wkP-UWn","copy":"_1yovI2LU","link":"_1ZgVN2Z_"};